import React, { Suspense } from 'react';

import { Routes } from 'react-router-dom';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring/SentryRoute';

import { RequireAuth, PageLoading } from './layout';

const Auth = React.lazy(async () => import('./auth'));
const Candidate = React.lazy(async () => import('./candidate'));

function App() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path="auth/*" element={<Auth />} />
        <Route
          path="*"
          element={
            <RequireAuth resource="Candidate" role="employee">
              <Candidate />
            </RequireAuth>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App;
